module.exports = __webpack_public_path__ + "bg_home_md.9ba8accf8bade93ebf36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/perfil/bg_home_md.jpg
// module id = 280
// module chunks = 2